export default "__VITE_ASSET__DbWgB$5N__"